import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';

interface IProps {
  value: number;
  onChange: (value: number) => void;
  cssClass?: string;
  fullWidth?: boolean;
  allowAny?: boolean;
  labelText?: string;
}

const BottleSizeSelect = (props: IProps) => {
  const { t } = useTranslation();
  const variants: number[] = [10, 25, 50, 80, 100, 150, 200, 250];

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;

    //callback
    props.onChange && props.onChange(value);
  };

  return (
    <FormControl className={props.cssClass} variant="outlined" fullWidth={props.fullWidth} size="small">
      <InputLabel id="bottleSizeSelect">{props.labelText || t('f-bottle-size')}</InputLabel>
      <Select
        label={props.labelText || t('f-bottle-size')}
        labelId="bottleSizeLabel"
        id="bottleSizeSelect"
        value={props.value}
        onChange={handleChange}
      >
        {variants.map((v) => (
          <MenuItem key={v} value={v}>
            {v} ml
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BottleSizeSelect;
